import {cssTheme} from '../theme'
import {css} from '../theme/css'

export const classes = {
  noSelectedItemHighlight: css`
    &:not(:hover) {
      ${cssTheme.components.listItems.bgColorHovered.token}: initial;
    }
  `,
}
